import React from 'react';
import Calendar from 'react-calendar';
import './calendar-styles.nomodules.scss';

const CalendarWithDefaultStyles = props => (
  <Calendar {...props} />
);

export default CalendarWithDefaultStyles;
